export default __webpack_public_path__ + "static/media/The Mouth of Barbed Promises.e8b70cfb.jpg";